import React, { useState, useEffect } from "react";

import Design from "./Design";
import { mostCharger } from "../../services/mostChargerApi";
const Benefit = () => {
  const [weeklyData1, setWeeklyData1] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      setError(null);
      try {
        const data1 = await mostCharger();
        setWeeklyData1(data1);
      } catch (err) {
        setError(err.message);
      } finally {
      }
    };

    fetchData();
  }, []);
  return (
    <div>
      <Design weeklyData1={weeklyData1} />
    </div>
  );
};

export default Benefit;
